/* ==========================================================================
   L'ATELIER DE LA POÊLE · script du guide de blog

   Généré par formatage/shopify/construire-js.py depuis les aperçus de partie
   et modules/ap-funnel.js. NE PAS ÉDITER LE FICHIER GÉNÉRÉ.
   Corriger la source correspondante, puis régénérer.

   Chaque zone est bornée à ses conteneurs « ap-zone--<zone> » et ne fait rien si
   la section est absente de la page.
   ========================================================================== */


/* --------------------------------------------------------------------------
   ZONE : OUVERTURE   (source : partie-1.html)
   -------------------------------------------------------------------------- */

document.querySelectorAll('.ap-zone--ouverture').forEach(function (racine) {
      // L'enveloppe .ap de la zone, jamais celle d'un funnel inséré dans la zone :
      // la carte produit placée avant un chapitre (guide.funnel_position) apporte
      // sa propre enveloppe .ap, que querySelector('.ap') trouvait en premier. La
      // zone restait alors sans .ap-js : tiroirs qui ne se refermaient plus,
      // flèche des tableaux absente, popups en ligne (28/09/2026)
      const horsFunnel = function (element) { return !element.closest('[data-ap-funnel-slot]'); };
      const article = Array.prototype.find.call(racine.querySelectorAll('.ap'), horsFunnel);
      if (!article) { return; }
      const mouvementReduit = window.matchMedia('(prefers-reduced-motion: reduce)');
      article.classList.add('ap-js');

      const sommaire = racine.querySelector('.ap-sommaire');
      if (sommaire) {
        const declencheur = sommaire.querySelector('.ap-sommaire__declencheur');
        const tiroir = sommaire.querySelector('.ap-sommaire__tiroir');
        const contenu = sommaire.querySelector('.ap-sommaire__contenu');
        sommaire.classList.remove('est-ouvert');
        declencheur.setAttribute('aria-expanded', 'false');
        contenu.hidden = true;
        tiroir.addEventListener('transitionend', function (evenement) {
          if (evenement.propertyName === 'grid-template-rows' && !sommaire.classList.contains('est-ouvert')) {
            contenu.hidden = true;
          }
        });
        declencheur.addEventListener('click', function () {
          const ouvert = !sommaire.classList.contains('est-ouvert');
          if (ouvert) {
            contenu.hidden = false;
            // Le fondu du contenu exige un état de départ déjà rendu
            void contenu.offsetHeight;
          }
          sommaire.classList.toggle('est-ouvert', ouvert);
          declencheur.setAttribute('aria-expanded', String(ouvert));
          if (!ouvert && (mouvementReduit.matches || !article.classList.contains('ap-anime'))) {
            contenu.hidden = true;
          }
        });
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          article.classList.add('ap-anime');
        });
      });

      racine.querySelectorAll('[data-cible]').forEach(function (bouton) {
        bouton.addEventListener('click', function () {
          // L'ancre visée vit dans une AUTRE zone de la page : le sommaire est en
          // ouverture, mais #cartes est dans les cartes, #faq dans la zone finale.
          // La chercher sous la racine de sa propre zone ne donnerait donc jamais
          // rien, et le bouton resterait sans effet. On passe par l'identifiant, à
          // l'échelle du document, seul endroit où toutes les ancres coexistent.
          const cible = document.getElementById(bouton.dataset.cible.replace('#', ''));
          if (!cible) return;
          cible.scrollIntoView({
            behavior: mouvementReduit.matches ? 'auto' : 'smooth',
            block: 'start'
          });
          cible.setAttribute('tabindex', '-1');
          cible.focus({ preventScroll: true });
        });
      });
    });

/* --------------------------------------------------------------------------
   ZONE : CARTES   (source : partie-2-popup.html)
   -------------------------------------------------------------------------- */

document.querySelectorAll('.ap-zone--cartes').forEach(function (racine) {
      // L'enveloppe .ap de la zone, jamais celle d'un funnel inséré dans la zone :
      // la carte produit placée avant un chapitre (guide.funnel_position) apporte
      // sa propre enveloppe .ap, que querySelector('.ap') trouvait en premier. La
      // zone restait alors sans .ap-js : tiroirs qui ne se refermaient plus,
      // flèche des tableaux absente, popups en ligne (28/09/2026)
      const horsFunnel = function (element) { return !element.closest('[data-ap-funnel-slot]'); };
      const article = Array.prototype.find.call(racine.querySelectorAll('.ap'), horsFunnel);
      if (!article) { return; }
      const mouvementReduit = window.matchMedia('(prefers-reduced-motion: reduce)');
      article.classList.add('ap-js');

      // Les cartes sont mises à part : observées une à une, les sept qui
      // patientent hors de la vitrine ne rencontraient jamais l'écran et
      // restaient à opacité zéro, alors que leur résumé, lui, gardait sa place
      // dans l'ordre de tabulation. Un lecteur au clavier ouvrait donc une fiche
      // rigoureusement invisible, sur une page qui se figeait derrière elle.
      // La rangée entière se découvre d'un coup, à l'arrivée de sa piste
      // Le carrousel : flèches et bords, la mécanique de la home
      const piste = racine.querySelector('.ap-cartes__piste');
      const prec = racine.querySelector('.ap-cartes__fleche--prec');
      const suiv = racine.querySelector('.ap-cartes__fleche--suiv');
      if (piste && prec && suiv) {
        const pas = function () {
          const carte = piste.querySelector('.ap-carte');
          if (!carte) return piste.clientWidth * 0.8;
          const gap = parseFloat(getComputedStyle(piste).columnGap || getComputedStyle(piste).gap) || 0;
          return carte.offsetWidth + gap;
        };
        const bords = function () {
          const debordement = piste.scrollWidth > piste.clientWidth + 4;
          const max = piste.scrollWidth - piste.clientWidth - 2;
          prec.disabled = !debordement || piste.scrollLeft <= 2;
          suiv.disabled = !debordement || piste.scrollLeft >= max;
        };
        prec.addEventListener('click', function () { piste.scrollBy({ left: -pas(), behavior: mouvementReduit.matches ? 'auto' : 'smooth' }); });
        suiv.addEventListener('click', function () { piste.scrollBy({ left: pas(), behavior: mouvementReduit.matches ? 'auto' : 'smooth' }); });
        piste.addEventListener('scroll', function () { window.requestAnimationFrame(bords); }, { passive: true });
        if (typeof ResizeObserver !== 'undefined') {
          new ResizeObserver(bords).observe(piste);
        } else {
          window.addEventListener('resize', bords);
        }
        bords();
      }

      // Les fiches en popup : fermeture au voile, à la croix, à Échap ;
      // le corps se fige tant qu'une fiche est ouverte
      const fiches = racine.querySelectorAll('.ap-fiche');
      // ---- Le gel du fond pendant qu'un popup est ouvert ----------------------
      // Il se fait en styles en ligne, jamais par une classe : la feuille du guide est
      // préfixée zone par zone, et une règle `.ap-fige` y devient
      // `.ap-zone--xxx .ap-fige`, qui ne peut jamais viser le <body> — celui-ci est un
      // ANCÊTRE de la zone, pas un descendant. La règle n'a donc jamais rien figé.
      //
      // `overflow: hidden` sur le corps ne suffit pas non plus sur iOS : Safari continue
      // d'y faire défiler la page. La seule méthode fiable est de sortir le corps du flux
      // et de mémoriser la position, pour la restituer à la fermeture. Constaté sur un
      // vrai iPhone le 01/09/2026 : la page défilait derrière le popup, qui semblait
      // passer à l'arrière-plan et se retrouvait tronqué.
      const gelerLeFond = function (doitGeler) {
        const corps = document.body;
        const dejaGele = corps.hasAttribute('data-ap-gel');
        if (doitGeler && !dejaGele) {
          const y = window.scrollY;
          corps.setAttribute('data-ap-gel', String(y));
          corps.style.position = 'fixed';
          corps.style.top = (-y) + 'px';
          corps.style.left = '0';
          corps.style.right = '0';
          corps.style.width = '100%';
        } else if (!doitGeler && dejaGele) {
          const y = parseInt(corps.getAttribute('data-ap-gel'), 10) || 0;
          corps.removeAttribute('data-ap-gel');
          corps.style.position = '';
          corps.style.top = '';
          corps.style.left = '';
          corps.style.right = '';
          corps.style.width = '';
          window.scrollTo(0, y);
        }
      };
      // `document.body.querySelector` et non `document.querySelector` : l'assembleur
      // borne les secondes à leur zone, or il faut ici voir les popups des DEUX zones,
      // sans quoi refermer l'un dégèlerait le fond pendant que l'autre est ouvert.
      const unPopupEstOuvert = function () {
        return !!document.body.querySelector('.ap-fiche[open], .ap-pfas[open]');
      };
      const majFige = function () { gelerLeFond(unPopupEstOuvert()); };
      // showModal() peint le dialogue dans la top layer : au-dessus de tout, hors
      // d'atteinte des conteneurs à défilement. C'est la seule parade fiable au
      // comportement d'iOS, qui peint un position:fixed DANS le carrousel qui
      // l'abrite et l'y découpe — le popup semblait incrusté derrière la page.
      // Constaté sur un vrai iPhone le 01/09/2026 ; invisible sur tout autre moteur.
      // Sans showModal (très vieux navigateurs), on retombe sur l'attribut open :
      // le panneau garde alors son position:fixed d'avant, découpe iOS comprise.
      const modalNatif = typeof HTMLDialogElement === 'function' && 'showModal' in HTMLDialogElement.prototype;
      fiches.forEach(function (fiche) {
        const panneau = fiche.querySelector('.ap-fiche__panneau');
        const bouton = fiche.querySelector('.ap-fiche__bouton');
        const fermer = fiche.querySelector('.ap-fiche__fermer');
        const defilant = fiche.querySelector('.ap-fiche__defilant');
        const indice = fiche.querySelector('.ap-fiche__indice');
        const carte = fiche.closest('.ap-carte');
        const nom = carte.querySelector('.ap-carte__nom');

        // Le panneau est un <dialog> : le rôle et aria-modal sont natifs. Seul le
        // libellé vient du script — du titre de la carte, jamais d'un texte ajouté
        if (nom) {
          panneau.setAttribute('aria-label', 'Carte d\'identité de ' + nom.textContent.replace(/\s*:\s*$/, '').replace(/^La\b/, 'la'));
        }

        const clore = function () { fiche.removeAttribute('open'); };
        fermer.addEventListener('click', clore);
        // Un clic sur le fond assombri (le ::backdrop) a pour cible le dialogue
        // lui-même ; un clic dans la fiche cible toujours un de ses enfants
        panneau.addEventListener('click', function (evenement) {
          if (evenement.target === panneau) clore();
        });
        // Échap ferme le dialogue nativement : on replie le details dans la foulée
        panneau.addEventListener('close', function () {
          if (fiche.open) fiche.removeAttribute('open');
        });
        defilant.addEventListener('scroll', function () {
          indice.classList.add('est-defile');
        }, { passive: true });

        // Le modal natif rend tout le reste de la page inerte : ce piège à Tab
        // n'existe plus que pour le repli sans showModal
        if (!modalNatif) panneau.addEventListener('keydown', function (evenement) {
          if (evenement.key !== 'Tab') return;
          evenement.preventDefault();
          if (document.activeElement === fermer) {
            panneau.focus({ preventScroll: true });
          } else {
            fermer.focus({ preventScroll: true });
          }
        });

        fiche.addEventListener('toggle', function () {
          majFige();
          if (fiche.open) {
            if (modalNatif) {
              if (!panneau.open) panneau.showModal();
            } else {
              panneau.setAttribute('open', '');
              panneau.focus({ preventScroll: true });
            }
            // La flèche ne s'affiche que s'il y a réellement de la lecture en dessous
            defilant.scrollTop = 0;
            window.requestAnimationFrame(function () {
              indice.classList.toggle('est-defile', defilant.scrollHeight <= defilant.clientHeight + 4);
            });
          } else {
            if (modalNatif) {
              if (panneau.open) panneau.close();
            } else {
              panneau.removeAttribute('open');
            }
            // Le focus revient d'où il venait : sans cela il repart en haut de page
            bouton.focus({ preventScroll: true });
          }
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          const ouverte = racine.querySelector('.ap-fiche[open]');
          if (ouverte) ouverte.removeAttribute('open');
        }
      });
    });

/* --------------------------------------------------------------------------
   ZONE : DIAGNOSTIC   (source : modules/ap-funnel.js — V2)
   -------------------------------------------------------------------------- */

/* Le HTML existe dès la réponse. JS ne crée ni lien ni requête de contenu. */
(function () {
  'use strict';
  const key = '__atelierFunnelV2';
  if (window[key]) { window[key].refresh(); return; }
  const wide = matchMedia('(min-width:1180px)');
  const reduce = matchMedia('(prefers-reduced-motion:reduce)');
  // Paliers du funnel produit, après la condensation continue (28/09/2026) : la carte garde toujours
  // sa taille publiée, c'est le reste du panneau qui se condense (ap-funnel.css).
  const PALIERS_PRODUIT = ['est-lecture-ligne', 'est-reassurance-courte', 'est-sans-reassurance', 'est-sans-lecture'];
  let dispose = [], frame = 0, generation = 0;
  function listen(target, name, handler, options) {
    target.addEventListener(name, handler, options);
    dispose.push(() => target.removeEventListener(name, handler, options));
  }
  function refresh() {
    const current = ++generation;
    dispose.splice(0).forEach(fn => fn());
    cancelAnimationFrame(frame);
    frame = 0;
    // Section re-rendering in the editor has no layout composition pass.
    document.querySelectorAll('ap-funnel-fragments').forEach(source => {
      const bureau=source.querySelector('ap-funnel-bureau')?.firstElementChild;
      const conversion=source.querySelector('ap-funnel-conversion')?.firstElementChild;
      const lecture=source.querySelector('ap-funnel-lecture')?.firstElementChild;
      const position=source.querySelector('ap-funnel-position')?.textContent.trim();
      const anchor=position ? Array.from(document.querySelectorAll('ap-funnel-ancre')).find(el=>el.dataset.apFunnelAnchor===position) : null;
      const target=anchor || (source.nextElementSibling?.matches('ap-funnel-emplacement') ? source.nextElementSibling : source);
      // Persistent markers let a later editor change move the conversion back
      // to its original position. Remove stale slots before inserting the new ones.
      document.querySelectorAll('[data-ap-funnel-slot]').forEach(slot=>{ if (!source.contains(slot)) slot.remove(); });
      if (conversion) target.after(conversion);
      const end=document.querySelector('ap-funnel-fin');
      if (lecture) { if (end) end.after(lecture);else source.closest('.shopify-section')?.after(lecture); }
      if (bureau) source.replaceWith(bureau);else source.remove();
    });
    const panel = document.querySelector('[data-ap-funnel-panel]');
    const nativeMobile = document.documentElement.dataset.apFunnelVariant === 'mobile';
    // A historical funnel section can be disabled while its reading slot lives
    // in another section. Never leave that old slot behind in the editor.
    if (!panel && !nativeMobile) document.querySelectorAll('[data-ap-funnel-slot]').forEach(slot=>slot.remove());
    document.querySelectorAll('.ap-funnel-relogee').forEach(wrapper=>{
      for(const selector of ['[data-ap-funnel-commerce]','[data-ap-funnel-reading]']){
        const node=wrapper.querySelector(selector);
        if(node && panel && !panel.querySelector(selector)) {
          if(selector.includes('commerce'))panel.prepend(node);else panel.append(node);
        }
      }
      wrapper.remove();
    });
    const desktop = panel?.closest('.ap-funnel-desktop');
    const zone = panel?.closest('.ap-zone');
    const commerce = panel?.querySelector('[data-ap-funnel-commerce]');
    const reading = panel?.querySelector('[data-ap-funnel-reading]');
    function ensureSlot(name, marker) {
      const existing=document.querySelector('[data-ap-funnel-slot="'+name+'"]');
      if (existing || !panel || !marker) return existing;
      // If an independently edited chapter/conclusion was replaced, recreate
      // only an empty destination. adapt() moves the already-rendered nodes.
      const slot=document.createElement('div');
      slot.className='ap-funnel-mobile ap-zone--diagnostic'+(name==='lecture'?' ap-funnel-fin':'');
      slot.dataset.apFunnelSlot=name;
      for(const prop of ['--ap-funnel-fond','--ap-funnel-texte'])slot.style.setProperty(prop,panel.style.getPropertyValue(prop));
      marker.after(slot);return slot;
    }
    const position=panel?.dataset.conversionPosition;
    const anchor=position ? Array.from(document.querySelectorAll('ap-funnel-ancre')).find(el=>el.dataset.apFunnelAnchor===position) : null;
    const commerceSlot = ensureSlot('conversion',anchor || document.querySelector('ap-funnel-emplacement'));
    const readingSlot = ensureSlot('lecture',document.querySelector('ap-funnel-fin'));
    const lateral = !!panel?.closest('.ap-diagnostic--lateral');
    const originalCommerce = commerce?.parentNode;
    const originalReading = reading?.parentNode;
    let tallPosition = null, lastY = scrollY, lastRoom = -1, dirty = true, tall = false;
    function move(node, slot, allowed, parent) {
      if (!node || !slot) return;
      // Without the edge (theme editor), Shopify already supplied both copies.
      if (slot.querySelector('[data-ap-funnel-mobile]')) return;
      if (!wide.matches && allowed) {
        if (!slot.contains(node)) {
          const wrap = document.createElement('div');
          wrap.className = 'ap ap-funnel-relogee';
          const shell=node===commerce ? slot.querySelector('[data-ap-funnel-mobile-shell]') : null;
          if (shell) {
            wrap.className='ap-funnel-relogee';wrap.append(node);
          } else if (node === commerce) {
            const inner = document.createElement('div');
            inner.className = 'ap-diagnostic' + (desktop?.querySelector('.ap-diagnostic--sombre') ? ' ap-diagnostic--sombre' : '');
            inner.append(node);wrap.append(inner);
          } else wrap.append(node);
          (shell || slot).prepend(wrap);
        }
      } else if (!parent.contains(node)) {
        if (node === commerce) parent.prepend(node); else parent.append(node);
        slot.querySelector('.ap-funnel-relogee')?.remove();
      }
    }
    function adapt() {
      if (!panel || nativeMobile) return;
      move(commerce, commerceSlot, panel.dataset.conversionMobile === 'true', originalCommerce);
      move(reading, readingSlot, panel.dataset.lectureMobile === 'true', originalReading);
    }
    function dimensions() {
      if (!panel || !lateral || !wide.matches || nativeMobile) {
        if (panel) panel.style.top = '';
        lastRoom = -1;
        return;
      }
      const scale = zone ? parseFloat(getComputedStyle(zone).getPropertyValue('--ap-echelle')) || 1 : 1;
      let header = 0;
      document.querySelectorAll('.shopify-section--announcement-bar,.shopify-section--header').forEach(el => {
        const b = el.getBoundingClientRect();
        if (b.top >= -1) header = Math.max(header, b.bottom);
      });
      const gap = parseFloat(getComputedStyle(panel).getPropertyValue('--ap-lateral-haut')) || 0;
      // En bas, la colonne garde le même écart avec le bord de l'écran, 10 px au plus (28/09/2026).
      const bottomGap = Math.min(gap, 10);
      const start = header / scale + gap;
      const room = Math.max(160, innerHeight / scale - start - bottomGap);
      // Reflow the contents only when the available space or content changes.
      // Ordinary page scrolling updates the position without toggling density.
      if (dirty || Math.abs(room - lastRoom) > 1) {
        panel.style.setProperty('--ap-entete', (header / scale) + 'px');
        panel.style.setProperty('--ap-disponible', room + 'px');
        const diagnostic = panel.dataset.apFunnelPanel === 'diagnostic';
        const primary = panel.querySelector('[data-ap-funnel-commerce]');
        panel.classList.remove('est-serree', 'est-haute', 'est-condensee', 'est-etiree', ...PALIERS_PRODUIT);
        panel.style.removeProperty('--ap-condense');
        const contentHeight = () => diagnostic ? primary?.scrollHeight || 0 : panel.scrollHeight;
        if (contentHeight() > room - 16) panel.classList.add('est-serree');
        // Produit (28/09/2026) : la carte ne change jamais de taille (photo carrée pleine largeur, comme
        // publiée) ; seul le reste se condense. D'abord en continu : espacements, réassurance et « À lire
        // ensuite » se resserrent juste assez (--ap-condense, de 0 à 1) pour remplir la hauteur libre.
        // Au-delà, palier par palier : « À lire ensuite » sur une ligne, la première ligne de la réassurance
        // seulement, sans la réassurance, la carte seule.
        // Tant que « À lire ensuite » reste affiché, le panneau descend jusqu'au bas de la hauteur libre et
        // l'y cale. Il ne suit la page (est-haute) que si la carte seule dépasse encore.
        if (panel.dataset.apFunnelPanel === 'produit' && contentHeight() > room + 1) {
          const condense = t => { panel.style.setProperty('--ap-condense', String(t)); return contentHeight(); };
          panel.classList.add('est-condensee');
          if (condense(1) <= room + 1) {
            let fits = 1, overflows = 0;
            for (let i = 0; i < 10; i++) {
              const t = (fits + overflows) / 2;
              if (condense(t) <= room + 1) fits = t; else overflows = t;
            }
            condense(fits);
          } else {
            for (const palier of PALIERS_PRODUIT) {
              if (contentHeight() <= room + 1) break;
              panel.classList.add(palier);
            }
          }
          if (reading && panel.contains(reading) && !panel.classList.contains('est-sans-lecture') && contentHeight() <= room + 1) panel.classList.add('est-etiree');
        }
        tall = !diagnostic && contentHeight() > room + 1;
        panel.classList.toggle('est-haute', tall);
        lastRoom = room;dirty = false;
      }
      const hero = document.querySelector('.ap-zone--ouverture .ap-hero');
      const beginning = hero ? hero.getBoundingClientRect().bottom / scale + 12 : start;
      const readingOnly = panel.dataset.apFunnelPanel === 'lecture';
      let top = start + (readingOnly ? Math.max(0, (room - panel.offsetHeight) / 2) : 0);
      if (tall) {
        const floor = innerHeight / scale - panel.offsetHeight - bottomGap;
        if (tallPosition === null) tallPosition = start;
        tallPosition -= (scrollY - lastY) / scale;
        top = Math.min(start, Math.max(floor, tallPosition));
        tallPosition = top;
      } else tallPosition = null;
      const zones = document.querySelectorAll('.ap-zone');
      const end = document.querySelector('.ap-zone--signature') || zones[zones.length - 1];
      const bottom = end?.getBoundingClientRect().bottom;
      if (bottom !== undefined) top = Math.min(top, bottom / scale - panel.offsetHeight);
      top = Math.max(beginning, top);
      if (panel.style.top !== top + 'px') panel.style.top = top + 'px';
      lastY = scrollY;
    }
    const schedule = () => {
      if (frame || current !== generation) return;
      frame = requestAnimationFrame(() => { frame = 0;dimensions(); });
    };
    const resize = () => { dirty = true;schedule(); };
    adapt();dimensions();
    if (panel) {
      listen(wide,'change',() => { adapt();resize(); });
      listen(window,'resize',resize);
      listen(window,'scroll',schedule,{passive:true});
      listen(window,'load',resize);
      let timer;
      listen(panel,'scroll',() => { panel.classList.add('a-defile');clearTimeout(timer);timer=setTimeout(() => panel.classList.remove('a-defile'),900); },{passive:true});
      dispose.push(() => clearTimeout(timer));
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(resize);
        document.querySelectorAll('.shopify-section--header,.shopify-section--announcement-bar,.ap-hero').forEach(el => observer.observe(el));
        dispose.push(() => observer.disconnect());
      }
      document.fonts?.ready.then(() => { if (panel.isConnected) resize(); });
    }
    document.querySelectorAll('[data-ap-funnel-commerce] .ap-defile').forEach(defile => {
      const track=defile.querySelector('.ap-piste'),prev=defile.querySelector('.ap-defile__prec'),next=defile.querySelector('.ap-defile__suiv');
      if (!track || !prev || !next) return;
      const update=()=>{ const max=track.scrollWidth-track.clientWidth;prev.disabled=track.scrollLeft<=1;next.disabled=track.scrollLeft>=max-1;defile.classList.toggle('est-fixe',max<=1); };
      const shift=direction=>{ const first=track.firstElementChild;const gap=parseFloat(getComputedStyle(track).columnGap)||10;track.scrollBy({left:direction*((first?.getBoundingClientRect().width||track.clientWidth)+gap),behavior:reduce.matches?'auto':'smooth'}); };
      listen(prev,'click',()=>shift(-1));listen(next,'click',()=>shift(1));listen(track,'scroll',update,{passive:true});listen(window,'resize',update);update();
      if ('ResizeObserver' in window) { const observer=new ResizeObserver(update);observer.observe(track);dispose.push(()=>observer.disconnect()); }
    });
    document.querySelectorAll('[data-ap-funnel-commerce] .ap-tiroir').forEach(details => {
      const summary=details.querySelector('summary');
      const sync=()=>{details.classList.toggle('est-ouvert',details.open);summary?.setAttribute('aria-expanded',String(details.open));resize();};
      listen(details,'toggle',sync);sync();
    });
    document.querySelectorAll('[data-cible="#diagnostic"]').forEach(button => { button.hidden=!document.getElementById('diagnostic'); });
    listen(document,'click',event=>{
      const trigger=event.target.closest?.('[data-cible="#diagnostic"]');
      if (!trigger || !panel || !wide.matches || !panel.querySelector('#diagnostic')) return;
      event.stopImmediatePropagation();
      panel.scrollTo({top:0,behavior:reduce.matches?'auto':'smooth'});
      panel.querySelector('.bouton-cta')?.focus({preventScroll:true});
    },true);
  }
  window[key]={refresh};
  document.addEventListener('shopify:section:load',refresh);
  document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(refresh));
  refresh();
})();


/* --------------------------------------------------------------------------
   ZONE : FAMILLES   (source : partie-1b-familles.html)
   -------------------------------------------------------------------------- */

document.querySelectorAll('.ap-zone--familles').forEach(function (racine) {
      // L'enveloppe .ap de la zone, jamais celle d'un funnel inséré dans la zone :
      // la carte produit placée avant un chapitre (guide.funnel_position) apporte
      // sa propre enveloppe .ap, que querySelector('.ap') trouvait en premier. La
      // zone restait alors sans .ap-js : tiroirs qui ne se refermaient plus,
      // flèche des tableaux absente, popups en ligne (28/09/2026)
      const horsFunnel = function (element) { return !element.closest('[data-ap-funnel-slot]'); };
      const article = Array.prototype.find.call(racine.querySelectorAll('.ap'), horsFunnel);
      if (!article) { return; }
      const mouvementReduit = window.matchMedia('(prefers-reduced-motion: reduce)');
      article.classList.add('ap-js');

      // Le carrousel du diptyque : flèches et bords, la mécanique des cartes
      // d'identité. Sur deux colonnes la piste ne déborde plus et les flèches
      // se désarment d'elles-mêmes
      const piste = racine.querySelector('.ap-familles__piste');
      const prec = racine.querySelector('.ap-familles__fleche--prec');
      const suiv = racine.querySelector('.ap-familles__fleche--suiv');
      if (piste && prec && suiv) {
        const pas = function () {
          const carte = piste.querySelector('.ap-famille');
          if (!carte) return piste.clientWidth * 0.8;
          const gap = parseFloat(getComputedStyle(piste).columnGap || getComputedStyle(piste).gap) || 0;
          return carte.offsetWidth + gap;
        };
        const bords = function () {
          const debordement = piste.scrollWidth > piste.clientWidth + 4;
          const max = piste.scrollWidth - piste.clientWidth - 2;
          prec.disabled = !debordement || piste.scrollLeft <= 2;
          suiv.disabled = !debordement || piste.scrollLeft >= max;
        };
        prec.addEventListener('click', function () { piste.scrollBy({ left: -pas(), behavior: mouvementReduit.matches ? 'auto' : 'smooth' }); });
        suiv.addEventListener('click', function () { piste.scrollBy({ left: pas(), behavior: mouvementReduit.matches ? 'auto' : 'smooth' }); });
        piste.addEventListener('scroll', function () { window.requestAnimationFrame(bords); }, { passive: true });
        if (typeof ResizeObserver !== 'undefined') {
          new ResizeObserver(bords).observe(piste);
        } else {
          window.addEventListener('resize', bords);
        }
        bords();
      }

      // La plus longue transition d'un élément, en millisecondes (durée et délai)
      const dureeTransition = function (element) {
        const style = getComputedStyle(element);
        const durees = style.transitionDuration.split(',');
        const delais = style.transitionDelay.split(',');
        return durees.reduce(function (max, duree, rang) {
          const total = (parseFloat(duree) || 0) + (parseFloat(delais[rang % delais.length]) || 0);
          return Math.max(max, total * 1000);
        }, 0);
      };

      // Les tiroirs des cartes : le details reste maître, le script n'anime que
      // la hauteur. Le tiroir PFAS n'en est pas un : il garde son propre langage
      Array.prototype.filter.call(racine.querySelectorAll('.ap-tiroir'), horsFunnel).forEach(function (tiroir) {
        const resume = tiroir.querySelector('.ap-tiroir__resume');
        const glisse = tiroir.querySelector('.ap-tiroir__glisse');
        let filet = 0;
        resume.setAttribute('aria-expanded', String(tiroir.open));
        if (tiroir.open) tiroir.classList.add('est-ouvert');
        // La fermeture attend la fin de la transition ; une transition annulée
        // (onglet en arrière-plan, rendu suspendu) doit refermer quand même
        const refermer = function (evenement) {
          if (evenement.propertyName === 'grid-template-rows' && !tiroir.classList.contains('est-ouvert')) {
            tiroir.open = false;
          }
        };
        glisse.addEventListener('transitionend', refermer);
        glisse.addEventListener('transitioncancel', refermer);
        // Une ouverture native hors clic (recherche dans la page) resynchronise l'état visuel
        tiroir.addEventListener('toggle', function () {
          if (tiroir.open !== tiroir.classList.contains('est-ouvert')) {
            tiroir.classList.toggle('est-ouvert', tiroir.open);
            resume.setAttribute('aria-expanded', String(tiroir.open));
          }
        });
        resume.addEventListener('click', function (evenement) {
          evenement.preventDefault();
          const ouverture = !tiroir.classList.contains('est-ouvert');
          if (ouverture) {
            clearTimeout(filet);
            tiroir.open = true;
            // La transition de hauteur exige un état de départ déjà rendu
            void glisse.offsetHeight;
            tiroir.classList.add('est-ouvert');
          } else {
            // Un popup ouvert dans ce tiroir doit se refermer avant lui : replié,
            // il ne serait plus atteignable et laisserait la page figée
            tiroir.querySelectorAll('.ap-pfas[open]').forEach(function (popup) {
              popup.removeAttribute('open');
            });
            tiroir.classList.remove('est-ouvert');
            // La fermeture attend la fin de la transition de hauteur. Sans transition
            // (mouvement réduit, animations pas encore armées), ou si elle n'aboutit
            // jamais, le details se referme quand même : aucun tiroir ne reste
            // bloqué ouvert (28/09/2026)
            const duree = mouvementReduit.matches || !article.classList.contains('ap-anime') ? 0 : dureeTransition(glisse);
            clearTimeout(filet);
            if (duree > 0) {
              filet = setTimeout(function () {
                if (!tiroir.classList.contains('est-ouvert')) tiroir.open = false;
              }, duree + 200);
            } else {
              tiroir.open = false;
            }
          }
          resume.setAttribute('aria-expanded', String(ouverture));
        });
      });

      // Le tiroir PFAS : les mêmes gestes que les fiches des cartes
      const pfas = racine.querySelector('.ap-pfas');
      // ---- Le gel du fond pendant qu'un popup est ouvert ----------------------
      // Il se fait en styles en ligne, jamais par une classe : la feuille du guide est
      // préfixée zone par zone, et une règle `.ap-fige` y devient
      // `.ap-zone--xxx .ap-fige`, qui ne peut jamais viser le <body> — celui-ci est un
      // ANCÊTRE de la zone, pas un descendant. La règle n'a donc jamais rien figé.
      //
      // `overflow: hidden` sur le corps ne suffit pas non plus sur iOS : Safari continue
      // d'y faire défiler la page. La seule méthode fiable est de sortir le corps du flux
      // et de mémoriser la position, pour la restituer à la fermeture. Constaté sur un
      // vrai iPhone le 01/09/2026 : la page défilait derrière le popup, qui semblait
      // passer à l'arrière-plan et se retrouvait tronqué.
      const gelerLeFond = function (doitGeler) {
        const corps = document.body;
        const dejaGele = corps.hasAttribute('data-ap-gel');
        if (doitGeler && !dejaGele) {
          const y = window.scrollY;
          corps.setAttribute('data-ap-gel', String(y));
          corps.style.position = 'fixed';
          corps.style.top = (-y) + 'px';
          corps.style.left = '0';
          corps.style.right = '0';
          corps.style.width = '100%';
        } else if (!doitGeler && dejaGele) {
          const y = parseInt(corps.getAttribute('data-ap-gel'), 10) || 0;
          corps.removeAttribute('data-ap-gel');
          corps.style.position = '';
          corps.style.top = '';
          corps.style.left = '';
          corps.style.right = '';
          corps.style.width = '';
          window.scrollTo(0, y);
        }
      };
      // `document.body.querySelector` et non `document.querySelector` : l'assembleur
      // borne les secondes à leur zone, or il faut ici voir les popups des DEUX zones,
      // sans quoi refermer l'un dégèlerait le fond pendant que l'autre est ouvert.
      const unPopupEstOuvert = function () {
        return !!document.body.querySelector('.ap-fiche[open], .ap-pfas[open]');
      };
      // showModal() peint le dialogue dans la top layer, hors d'atteinte du tiroir
      // et du carrousel qui l'abritent : c'est la parade au comportement d'iOS qui
      // découpe un position:fixed dans son conteneur à défilement (01/09/2026)
      const modalNatif = typeof HTMLDialogElement === 'function' && 'showModal' in HTMLDialogElement.prototype;
      if (pfas) {
        const panneauPfas = pfas.querySelector('.ap-pfas__panneau');
        const clorePfas = function () { pfas.removeAttribute('open'); };
        pfas.querySelector('.ap-pfas__fermer').addEventListener('click', clorePfas);
        // Un clic sur le fond assombri (le ::backdrop) a pour cible le dialogue
        // lui-même ; un clic dans la fiche cible toujours un de ses enfants
        panneauPfas.addEventListener('click', function (evenement) {
          if (evenement.target === panneauPfas) clorePfas();
        });
        // Échap ferme le dialogue nativement : on replie le details dans la foulée
        panneauPfas.addEventListener('close', function () {
          if (pfas.open) pfas.removeAttribute('open');
        });
        const lienPfas = pfas.querySelector('.ap-pfas__lien');
        pfas.addEventListener('toggle', function () {
          gelerLeFond(unPopupEstOuvert());
          if (pfas.open) {
            if (modalNatif) {
              if (!panneauPfas.open) panneauPfas.showModal();
            } else {
              panneauPfas.setAttribute('open', '');
              panneauPfas.focus({ preventScroll: true });
            }
            panneauPfas.scrollTop = 0;
          } else {
            if (modalNatif) {
              if (panneauPfas.open) panneauPfas.close();
            } else {
              panneauPfas.removeAttribute('open');
            }
            if (lienPfas) {
              // Le focus revient d'où il venait : sans cela il repart en haut de page
              lienPfas.focus({ preventScroll: true });
            }
          }
        });
        document.addEventListener('keydown', function (evenement) {
          if (evenement.key === 'Escape' && pfas.open) clorePfas();
        });
      }

      // Les transitions des tiroirs ne s'arment qu'une fois la page posée
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          article.classList.add('ap-anime');
        });
      });
    });

/* --------------------------------------------------------------------------
   ZONE : METHODE   (source : partie-3.html)
   -------------------------------------------------------------------------- */

document.querySelectorAll('.ap-zone--methode').forEach(function (racine) {
      // La remontée vers le diagnostic : les mêmes gestes que le sommaire
      const mouvementReduit = window.matchMedia('(prefers-reduced-motion: reduce)');
      racine.querySelectorAll('[data-cible]').forEach(function (bouton) {
        bouton.addEventListener('click', function () {
          // L'ancre visée vit dans une AUTRE zone de la page : le sommaire est en
          // ouverture, mais #cartes est dans les cartes, #faq dans la zone finale.
          // La chercher sous la racine de sa propre zone ne donnerait donc jamais
          // rien, et le bouton resterait sans effet. On passe par l'identifiant, à
          // l'échelle du document, seul endroit où toutes les ancres coexistent.
          const cible = document.getElementById(bouton.dataset.cible.replace('#', ''));
          if (!cible) return;
          cible.scrollIntoView({
            behavior: mouvementReduit.matches ? 'auto' : 'smooth',
            block: 'start'
          });
          cible.setAttribute('tabindex', '-1');
          cible.focus({ preventScroll: true });
        });
      });
    });

/* --------------------------------------------------------------------------
   ZONE : FIN   (source : partie-4-fin.html)
   -------------------------------------------------------------------------- */

document.querySelectorAll('.ap-zone--fin').forEach(function (racine) {
      // L'enveloppe .ap de la zone, jamais celle d'un funnel inséré dans la zone :
      // la carte produit placée avant un chapitre (guide.funnel_position) apporte
      // sa propre enveloppe .ap, que querySelector('.ap') trouvait en premier. La
      // zone restait alors sans .ap-js : tiroirs qui ne se refermaient plus,
      // flèche des tableaux absente, popups en ligne (28/09/2026)
      const horsFunnel = function (element) { return !element.closest('[data-ap-funnel-slot]'); };
      const article = Array.prototype.find.call(racine.querySelectorAll('.ap'), horsFunnel);
      if (!article) { return; }
      const mouvementReduit = window.matchMedia('(prefers-reduced-motion: reduce)');
      article.classList.add('ap-js');

      // La plus longue transition d'un élément, en millisecondes (durée et délai)
      const dureeTransition = function (element) {
        const style = getComputedStyle(element);
        const durees = style.transitionDuration.split(',');
        const delais = style.transitionDelay.split(',');
        return durees.reduce(function (max, duree, rang) {
          const total = (parseFloat(duree) || 0) + (parseFloat(delais[rang % delais.length]) || 0);
          return Math.max(max, total * 1000);
        }, 0);
      };

      // Les tiroirs de la FAQ : le details reste maître, le script n'anime que la hauteur
      Array.prototype.filter.call(racine.querySelectorAll('.ap-tiroir'), horsFunnel).forEach(function (tiroir) {
        const resume = tiroir.querySelector('.ap-tiroir__resume');
        const glisse = tiroir.querySelector('.ap-tiroir__glisse');
        let filet = 0;
        resume.setAttribute('aria-expanded', String(tiroir.open));
        if (tiroir.open) tiroir.classList.add('est-ouvert');
        glisse.addEventListener('transitionend', function (evenement) {
          if (evenement.propertyName === 'grid-template-rows' && !tiroir.classList.contains('est-ouvert')) {
            tiroir.open = false;
          }
        });
        // Une ouverture native hors clic (recherche dans la page) resynchronise l'état visuel
        tiroir.addEventListener('toggle', function () {
          if (tiroir.open !== tiroir.classList.contains('est-ouvert')) {
            tiroir.classList.toggle('est-ouvert', tiroir.open);
            resume.setAttribute('aria-expanded', String(tiroir.open));
          }
        });
        resume.addEventListener('click', function (evenement) {
          evenement.preventDefault();
          const ouverture = !tiroir.classList.contains('est-ouvert');
          if (ouverture) {
            clearTimeout(filet);
            tiroir.open = true;
            // La transition de hauteur exige un état de départ déjà rendu
            void glisse.offsetHeight;
            tiroir.classList.add('est-ouvert');
          } else {
            tiroir.classList.remove('est-ouvert');
            // La fermeture attend la fin de la transition de hauteur. Sans transition
            // (mouvement réduit, animations pas encore armées), ou si elle n'aboutit
            // jamais, le details se referme quand même : aucun tiroir ne reste
            // bloqué ouvert (28/09/2026)
            const duree = mouvementReduit.matches || !article.classList.contains('ap-anime') ? 0 : dureeTransition(glisse);
            clearTimeout(filet);
            if (duree > 0) {
              filet = setTimeout(function () {
                if (!tiroir.classList.contains('est-ouvert')) tiroir.open = false;
              }, duree + 200);
            } else {
              tiroir.open = false;
            }
          }
          resume.setAttribute('aria-expanded', String(ouverture));
        });
      });

      // Le carrousel mobile des deux verdicts : flèches et bords
      const verdictsPiste = racine.querySelector('.ap-verdicts__piste');
      const verdictsPrec = racine.querySelector('.ap-verdicts__fleche--prec');
      const verdictsSuiv = racine.querySelector('.ap-verdicts__fleche--suiv');
      if (verdictsPiste && verdictsPrec && verdictsSuiv) {
        const pas = function () {
          const panneau = verdictsPiste.querySelector('.ap-verdict');
          if (!panneau) return verdictsPiste.clientWidth * 0.8;
          const gap = parseFloat(getComputedStyle(verdictsPiste).columnGap || getComputedStyle(verdictsPiste).gap) || 0;
          return panneau.offsetWidth + gap;
        };
        const bords = function () {
          const debordement = verdictsPiste.scrollWidth > verdictsPiste.clientWidth + 4;
          const max = verdictsPiste.scrollWidth - verdictsPiste.clientWidth - 2;
          verdictsPrec.disabled = !debordement || verdictsPiste.scrollLeft <= 2;
          verdictsSuiv.disabled = !debordement || verdictsPiste.scrollLeft >= max;
        };
        verdictsPrec.addEventListener('click', function () { verdictsPiste.scrollBy({ left: -pas(), behavior: mouvementReduit.matches ? 'auto' : 'smooth' }); });
        verdictsSuiv.addEventListener('click', function () { verdictsPiste.scrollBy({ left: pas(), behavior: mouvementReduit.matches ? 'auto' : 'smooth' }); });
        verdictsPiste.addEventListener('scroll', function () { window.requestAnimationFrame(bords); }, { passive: true });
        if (typeof ResizeObserver !== 'undefined') {
          new ResizeObserver(bords).observe(verdictsPiste);
        } else {
          window.addEventListener('resize', bords);
        }
        bords();
      }

      // L'indice de la table et son arrêt de tabulation : montés seulement
      // quand elle a de quoi défiler (le tabindex du HTML reste l'état no-JS,
      // où la table peut toujours défiler), l'indice effacé au premier geste ;
      // l'état complet se recalcule à chaque redimensionnement
      // Plusieurs tableaux dans une zone (09/09/2026) : chacun a son indice et son
      // propre état de débordement
      racine.querySelectorAll('.ap-match').forEach(function (match) {
        const defilement = match.querySelector('.ap-match__defilement');
        const indice = match.querySelector('.ap-match__indice');
        let aDefile = false;
        const majDebordement = function () {
          const deborde = defilement.scrollWidth > defilement.clientWidth + 4;
          match.classList.toggle('a-defilement', deborde);
          if (deborde) {
            defilement.setAttribute('tabindex', '0');
          } else {
            defilement.removeAttribute('tabindex');
          }
          indice.classList.toggle('est-defile', aDefile || !deborde);
        };
        defilement.addEventListener('scroll', function () {
          aDefile = true;
          indice.classList.add('est-defile');
        }, { passive: true });
        if (typeof ResizeObserver !== 'undefined') {
          new ResizeObserver(majDebordement).observe(defilement);
        } else {
          window.addEventListener('resize', majDebordement);
        }
        majDebordement();
      });

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          article.classList.add('ap-anime');
        });
      });
    });

/* --------------------------------------------------------------------------
   ZONE : CHAPITRE   (source : partie-6-chapitre.html)
   -------------------------------------------------------------------------- */

document.querySelectorAll('.ap-zone--chapitre').forEach(function (racine) {
      // L'enveloppe .ap de la zone, jamais celle d'un funnel inséré dans la zone :
      // la carte produit placée avant un chapitre (guide.funnel_position) apporte
      // sa propre enveloppe .ap, que querySelector('.ap') trouvait en premier. La
      // zone restait alors sans .ap-js : tiroirs qui ne se refermaient plus,
      // flèche des tableaux absente, popups en ligne (28/09/2026)
      const horsFunnel = function (element) { return !element.closest('[data-ap-funnel-slot]'); };
      const article = Array.prototype.find.call(racine.querySelectorAll('.ap'), horsFunnel);
      if (!article) { return; }
      const mouvementReduit = window.matchMedia('(prefers-reduced-motion: reduce)');
      article.classList.add('ap-js');

      // ---- Le gel du fond pendant qu'un popup est ouvert ----------------------
      // En styles en ligne, jamais par une classe : la feuille du guide est
      // préfixée zone par zone, et une règle `.ap-fige` ne pourrait jamais viser
      // le <body>. Sortir le corps du flux et mémoriser la position est la seule
      // méthode fiable sur iOS.
      const gelerLeFond = function (doitGeler) {
        const corps = document.body;
        const dejaGele = corps.hasAttribute('data-ap-gel');
        if (doitGeler && !dejaGele) {
          const y = window.scrollY;
          corps.setAttribute('data-ap-gel', String(y));
          corps.style.position = 'fixed';
          corps.style.top = (-y) + 'px';
          corps.style.left = '0';
          corps.style.right = '0';
          corps.style.width = '100%';
        } else if (!doitGeler && dejaGele) {
          const y = parseInt(corps.getAttribute('data-ap-gel'), 10) || 0;
          corps.removeAttribute('data-ap-gel');
          corps.style.position = '';
          corps.style.top = '';
          corps.style.left = '';
          corps.style.right = '';
          corps.style.width = '';
          window.scrollTo(0, y);
        }
      };
      // `document.body.querySelector` et non `document.querySelector` : il faut
      // voir les popups de TOUTES les zones avant de dégeler le fond.
      const unPopupEstOuvert = function () {
        return !!document.body.querySelector('.ap-fiche[open], .ap-pfas[open], .ap-plus[open]');
      };
      const modalNatif = typeof HTMLDialogElement === 'function' && 'showModal' in HTMLDialogElement.prototype;

      // Les popups « En savoir plus » : les mêmes gestes que la fiche PFAS des familles
      racine.querySelectorAll('.ap-plus').forEach(function (plus) {
        const panneau = plus.querySelector('.ap-plus__panneau');
        const lien = plus.querySelector('.ap-plus__lien');
        const fermer = plus.querySelector('.ap-plus__fermer');
        if (!panneau || !lien || !fermer) { return; }
        const clore = function () { plus.removeAttribute('open'); };
        fermer.addEventListener('click', clore);
        panneau.addEventListener('click', function (evenement) {
          if (evenement.target === panneau) clore();
        });
        panneau.addEventListener('close', function () {
          // Un « close » retardé lors d'une réouverture rapide ne doit pas refermer
          // le details (porté de la session revêtement, 09/09/2026)
          if (plus.open && !panneau.open) plus.removeAttribute('open');
        });
        plus.addEventListener('toggle', function () {
          gelerLeFond(unPopupEstOuvert());
          if (plus.open) {
            if (modalNatif) {
              if (!panneau.open) panneau.showModal();
            } else {
              panneau.setAttribute('open', '');
              panneau.focus({ preventScroll: true });
            }
            panneau.scrollTop = 0;
          } else {
            if (modalNatif) {
              if (panneau.open) panneau.close();
            } else {
              panneau.removeAttribute('open');
            }
            lien.focus({ preventScroll: true });
          }
        });
      });

      // Le dialogue de chaque popup reçoit un nom accessible, sans changer son
      // comportement natif (porté de la session revêtement, 09/09/2026 ; le compteur
      // est global pour que les identifiants restent uniques d'une zone à l'autre)
      racine.querySelectorAll('.ap-plus').forEach(function (note) {
        const panneau = note.querySelector('.ap-plus__panneau');
        const titre = note.querySelector('.ap-plus__titre');
        const lien = note.querySelector('.ap-plus__lien');
        if (!panneau || !titre || !lien) return;
        window.apSourceCompteur = (window.apSourceCompteur || 0) + 1;
        const index = window.apSourceCompteur;
        titre.id = titre.id || 'ap-source-titre-' + index;
        panneau.id = panneau.id || 'ap-source-dialogue-' + index;
        panneau.setAttribute('aria-labelledby', titre.id);
        lien.setAttribute('aria-haspopup', 'dialog');
        lien.setAttribute('aria-controls', panneau.id);
      });
      document.addEventListener('keydown', function (evenement) {
        if (evenement.key !== 'Escape') { return; }
        const ouvert = racine.querySelector('.ap-plus[open]');
        if (ouvert) ouvert.removeAttribute('open');
      });

      // La plus longue transition d'un élément, en millisecondes (durée et délai)
      const dureeTransition = function (element) {
        const style = getComputedStyle(element);
        const durees = style.transitionDuration.split(',');
        const delais = style.transitionDelay.split(',');
        return durees.reduce(function (max, duree, rang) {
          const total = (parseFloat(duree) || 0) + (parseFloat(delais[rang % delais.length]) || 0);
          return Math.max(max, total * 1000);
        }, 0);
      };

      // Les tiroirs : le details reste maître, le script n'anime que la hauteur
      Array.prototype.filter.call(racine.querySelectorAll('.ap-tiroir'), horsFunnel).forEach(function (tiroir) {
        const resume = tiroir.querySelector('.ap-tiroir__resume');
        const glisse = tiroir.querySelector('.ap-tiroir__glisse');
        let filet = 0;
        if (!resume || !glisse) { return; }
        resume.setAttribute('aria-expanded', String(tiroir.open));
        if (tiroir.open) tiroir.classList.add('est-ouvert');
        const refermer = function (evenement) {
          if (evenement.propertyName === 'grid-template-rows' && !tiroir.classList.contains('est-ouvert')) {
            tiroir.open = false;
          }
        };
        glisse.addEventListener('transitionend', refermer);
        glisse.addEventListener('transitioncancel', refermer);
        tiroir.addEventListener('toggle', function () {
          if (tiroir.open !== tiroir.classList.contains('est-ouvert')) {
            tiroir.classList.toggle('est-ouvert', tiroir.open);
            resume.setAttribute('aria-expanded', String(tiroir.open));
          }
        });
        resume.addEventListener('click', function (evenement) {
          evenement.preventDefault();
          const ouverture = !tiroir.classList.contains('est-ouvert');
          if (ouverture) {
            clearTimeout(filet);
            tiroir.open = true;
            void glisse.offsetHeight;
            tiroir.classList.add('est-ouvert');
          } else {
            // Un popup ouvert dans ce tiroir se referme avant lui
            tiroir.querySelectorAll('.ap-plus[open]').forEach(function (popup) {
              popup.removeAttribute('open');
            });
            tiroir.classList.remove('est-ouvert');
            // La fermeture attend la fin de la transition de hauteur. Sans transition
            // (mouvement réduit, animations pas encore armées), ou si elle n'aboutit
            // jamais, le details se referme quand même : aucun tiroir ne reste
            // bloqué ouvert (28/09/2026)
            const duree = mouvementReduit.matches || !article.classList.contains('ap-anime') ? 0 : dureeTransition(glisse);
            clearTimeout(filet);
            if (duree > 0) {
              filet = setTimeout(function () {
                if (!tiroir.classList.contains('est-ouvert')) tiroir.open = false;
              }, duree + 200);
            } else {
              tiroir.open = false;
            }
          }
          resume.setAttribute('aria-expanded', String(ouverture));
        });
      });

      // Le tableau : l'indice de défilement, monté seulement quand il y a de quoi défiler
      racine.querySelectorAll('.ap-tableau').forEach(function (tableau) {
        const defilement = tableau.querySelector('.ap-tableau__defilement');
        const indice = tableau.querySelector('.ap-tableau__indice');
        if (!defilement || !indice) { return; }
        let aDefile = false;
        const majDebordement = function () {
          const deborde = defilement.scrollWidth > defilement.clientWidth + 4;
          tableau.classList.toggle('a-defilement', deborde);
          if (deborde) {
            defilement.setAttribute('tabindex', '0');
          } else {
            defilement.removeAttribute('tabindex');
          }
          indice.classList.toggle('est-defile', aDefile || !deborde);
        };
        defilement.addEventListener('scroll', function () {
          aDefile = true;
          indice.classList.add('est-defile');
        }, { passive: true });
        if (typeof ResizeObserver !== 'undefined') {
          new ResizeObserver(majDebordement).observe(defilement);
        } else {
          window.addEventListener('resize', majDebordement);
        }
        majDebordement();
      });

      // Les panneaux défilants (téléphone, v4.1, 13/09/2026) : la flèche avance d'un
      // volet, s'efface au dernier, et ne se montre que s'il y a de quoi défiler
      racine.querySelectorAll('.ap-defilement').forEach(function (bloc) {
        const piste = bloc.querySelector('.ap-dossier--defilant');
        const fleche = bloc.querySelector('.ap-defilement__fleche');
        if (!piste || !fleche) { return; }
        const majFleche = function () {
          const deborde = piste.scrollWidth > piste.clientWidth + 4;
          const auBout = piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 8;
          fleche.classList.toggle('est-au-bout', !deborde || auBout);
        };
        fleche.addEventListener('click', function () {
          const volet = piste.querySelector('.ap-volet');
          const ecart = parseFloat(getComputedStyle(piste).columnGap) || 0;
          const pas = volet ? volet.getBoundingClientRect().width + ecart : piste.clientWidth * 0.86;
          piste.scrollBy({ left: pas, behavior: mouvementReduit.matches ? 'auto' : 'smooth' });
        });
        piste.addEventListener('scroll', majFleche, { passive: true });
        if (typeof ResizeObserver !== 'undefined') {
          new ResizeObserver(majFleche).observe(piste);
        } else {
          window.addEventListener('resize', majFleche);
        }
        majFleche();
      });

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          article.classList.add('ap-anime');
        });
      });
    });
